import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { VerificationSession } from '../services/verification-session.service';

@Injectable()
export class VerificationRedirectionService implements CanActivate {

  constructor(private verificationSession: VerificationSession) {
  }

  canActivate(router: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return true;
    // return router.url[0].path === 'resultat' && this.verificationSession.verificationResponseData != null;
  }
}
